module.exports = "<div class=\"container\">\n  <div class=\"row\">\n\n    <div class=\"col-lg-6 offset-lg-3\">\n\n      {{message}}\n\n      <form (ngSubmit)=\"login()\" #f=\"ngForm\">\n        <input placeholder=\"Password\" [(ngModel)]=\"password\" name=\"password\" required>\n\n        <button type=\"submit\" [disabled]=\"!f.valid\">Login</button>\n      </form>\n\n\n    </div>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/login/login.component.html
// module id = ../../../../../src/app/pages/login/login.component.html
// module chunks = main